export const EDUCATION_LOADING = "EDUCATION_LOADING";
export const EDUCATION_SUCCESS = "EDUCATION_SUCCESS";
export const EDUCATION_FAILED = "EDUCATION_FAILED";

export const EDUCATION_ADD_LOADING = "EDUCATION_ADD_LOADING";
export const EDUCATION_ADD_SUCCESS = "EDUCATION_ADD_SUCCESS";
export const EDUCATION_ADD_FAILED = "EDUCATION_ADD_FAILED";

export const EDUCATION_REMOVE_LOADING = "EDUCATION_REMOVE_LOADING";
export const EDUCATION_REMOVE_SUCCESS = "EDUCATION_REMOVE_SUCCESS";
export const EDUCATION_REMOVE_FAILED = "EDUCATION_REMOVE_FAILED";

export const EDUCATION_UPDATE_CAMPUS_HIRE_LOADING = "EDUCATION_UPDATE_CAMPUS_HIRE_LOADING";
export const EDUCATION_UPDATE_CAMPUS_HIRE_SUCCESS = "EDUCATION_UPDATE_CAMPUS_HIRE_SUCCESS";
export const EDUCATION_UPDATE_CAMPUS_HIRE_FAILED = "EDUCATION_UPDATE_CAMPUS_HIRE_FAILED";

export const EDUCATION_SAVE_LOADING = "EDUCATION_SAVE_LOADING";
export const EDUCATION_SAVE_SUCCESS = "EDUCATION_SAVE_SUCCESS";
export const EDUCATION_SAVE_FAILED = "EDUCATION_SAVE_FAILED";

export const MRL_DOCUMENT_LOADING = "MRL_DOCUMENT_LOADING";
export const MRL_DOCUMENT_SUCCESS = "MRL_DOCUMENT_SUCCESS";
export const MRL_DOCUMENT_FAILED = "MRL_DOCUMENT_FAILED";
export const MRL_DOCUMENT_RESET = "MRL_DOCUMENT_RESET";

// New Education form changes

export const STATE_UNIVERSITY_LOADING = "STATE_UNIVERSITY_LOADING";
export const STATE_UNIVERSITY_SUCCESS = "STATE_UNIVERSITY_SUCCESS";
export const STATE_UNIVERSITY_FAILED = "STATE_UNIVERSITY_FAILED";

  